import { style, media } from 'typestyle'
export const ml12md = style(media({ maxWidth: 768 }, { marginLeft: '12px' }))
